let cartLoadCounter = 0;
let bubbleCount;
let cartAvailable;
var allProducts = {
    "42895585935552": {
        handle: 'pure-unsweetened-frozen-acai-packets',
        variant: 42895585935552,
        custom_bulk_quantity_selector: true,
        sku: '2841100422',
        id: 7290602619072,
        quantities: [
            {quantity: 10, price: 649, discount: 0},
            {quantity: 15, price: 599, discount: 0.50},
            {quantity: 20, price: 549, discount: 1},
            {quantity: 25, price: 529, discount: 1.20}
        ],
        original_price: 649,
        type: 'Bag',
        highest_bulk_option: 25,
        lowest_bulk_option: 10,
        discount_type: 'dollar'
    },
    "41567435227328": {
        handle: 'original-blend-frozen-acai-packets',
        variant: 41567435227328,
        custom_bulk_quantity_selector: true,
        sku: '200000049',
        id: 41567435227328,
        quantities: [
            {quantity: 10, price: 649, discount: 0},
            {quantity: 15, price: 599, discount: 0.50},
            {quantity: 20, price: 549, discount: 1},
            {quantity: 25, price: 529, discount: 1.20}
        ],
        original_price: 649,
        type: 'Bag',
        highest_bulk_option: 25,
        lowest_bulk_option: 10,
        discount_type: 'dollar'
    },
    "38126779531456": {
        handle: 'tropical-immunity-frozen-acerola-packets',
        variant: 38126779531456,
        custom_bulk_quantity_selector: true,
        id: 6200192794816,
        sku: '2841100398',
        quantities: [
            {quantity: 10, price: 649, discount: 0}
        ],
        original_price: 649,
        type: 'Bag',
        highest_bulk_option: 10,
        lowest_bulk_option: 10,
        discount_type: 'percent'
    },
    "38124114968768": {
        handle: 'performance-protein-frozen-acai-packets',
        variant: 38124114968768,
        custom_bulk_quantity_selector: true,
        id: 6199626301632,
        sku: '2841100400',
        quantities: [
            {quantity: 10, price: 649, discount: 0}
        ],
        original_price: 649,
        type: 'Bag',
        highest_bulk_option: 10,
        lowest_bulk_option: 10,
        discount_type: 'percent'
    },
    "38126795129024": {
        handle: 'supergreens-frozen-acai-packets',
        variant: 38126795129024,
        custom_bulk_quantity_selector: true,
        id: 6200195711168,
        sku: '2841100395',
        quantities: [
            {quantity: 10, price: 649, discount: 0}
        ],
        original_price: 649,
        type: 'Bag',
        highest_bulk_option: 10,
        lowest_bulk_option: 10,
        discount_type: 'percent'
    },
    "42895867019456": {
        handle: 'red-dragon-frozen-fruit-cubes',
        variant: 42895867019456,
        custom_bulk_quantity_selector: true,
        id: 7290610974912,
        sku: '2841100453',
        quantities: [
            {quantity: 10, price: 649, discount: 0}
        ],
        original_price: 649,
        type: 'Bag',
        highest_bulk_option: 10,
        lowest_bulk_option: 10,
        discount_type: 'percent'
    },
    "39909559861440": {
        handle: 'peanut-butter-power-acai-bowl',
        variant: 39909559861440,
        custom_bulk_quantity_selector: true,
        id: 6699122360512,
        sku: '1841100319',
        quantities: [
            {quantity: 18, price: 399, discount: 0.51}
        ],
        original_price: 450,
        type: 'Bowl',
        highest_bulk_option: 18,
        lowest_bulk_option: 18,
        discount_type: 'dollar'
    },
    "39909558616256": {
        handle: 'amazon-superberry-acai-bowl',
        variant: 39909558616256,
        custom_bulk_quantity_selector: true,
        id: 6699122098368,
        sku: '1841100318',
        quantities: [
            {quantity: 18, price: 399, discount: 0.51}
        ],
        original_price: 450,
        type: 'Bowl',
        highest_bulk_option: 18,
        lowest_bulk_option: 18,
        discount_type: 'dollar'
    },
    "39909555241152": {
        handle: 'berry-bliss-acai-bowl',
        variant: 39909555241152,
        custom_bulk_quantity_selector: true,
        id: 6699121508544,
        sku: '2841100384',
        quantities: [
            {quantity: 18, price: 399, discount: 0.51}
        ],
        original_price: 450,
        type: 'Bowl',
        highest_bulk_option: 18,
        lowest_bulk_option: 18,
        discount_type: 'dollar'
    },
    "39909587550400": {
        handle: 'bamboo-cup',
        variant: 39909587550400,
        custom_bulk_quantity_selector: false,
        id: 6699126128832,
        sku: '990074',
        quantities: [
            {quantity: 1, price: 1500, discount: 0},
            {quantity: 2, price: 1500, discount: 0},
            {quantity: 3, price: 1500, discount: 0},
            {quantity: 4, price: 1200, discount: 20},
            {quantity: 5, price: 1200, discount: 20},
            {quantity: 6, price: 1200, discount: 20},
            {quantity: 7, price: 1200, discount: 20},
            {quantity: 8, price: 1200, discount: 20}
        ],
        original_price: 1500,
        type: 'Cup',
        highest_bulk_option: 4,
        lowest_bulk_option: 1,
        discount_type: 'percent'
    },
    "39909585715392": {
        handle: 'coconut-bowls',
        variant: 39909585715392,
        custom_bulk_quantity_selector: false,
        id: 6699125899456,
        sku: '990073',
        quantities: [
            {quantity: 1, price: 1500, discount: 0},
            {quantity: 2, price: 1500, discount: 0},
            {quantity: 3, price: 1500, discount: 0},
            {quantity: 4, price: 1200, discount: 20},
            {quantity: 5, price: 1200, discount: 20},
            {quantity: 6, price: 1200, discount: 20},
            {quantity: 7, price: 1200, discount: 20},
            {quantity: 8, price: 1200, discount: 20}
        ],
        original_price: 1500,
        type: 'Cup',
        highest_bulk_option: 4,
        lowest_bulk_option: 1,
        discount_type: 'percent'
    },
    "39909590302912": {
        handle: 'wooden-spoon',
        variant: 39909590302912,
        custom_bulk_quantity_selector: true,
        id: 6699128094912,
        sku: '990080',
        quantities: [
            {quantity: 2, price: 600, discount: 0},
            {quantity: 4, price: 500, discount: 1}
        ],
        original_price: 600,
        type: 'Spoon',
        highest_bulk_option: 4,
        lowest_bulk_option: 2,
        discount_type: 'dollar'
    },
    "39909592727744": {
        handle: 'acai-seed-bracelet',
        variant: 39909592727744,
        custom_bulk_quantity_selector: true,
        id: 6699128357056,
        sku: '990001',
        quantities: [
            {quantity: 1, price: 500, discount: 0}
        ],
        original_price: 500,
        type: 'Bracelet',
        highest_bulk_option: 1,
        lowest_bulk_option: 1,
        discount_type: 'dollar'
    },
    "39909592924352": {
        handle: 'acai-seed-necklace',
        variant: 39909592924352,
        custom_bulk_quantity_selector: true,
        id: 6699128553664,
        sku: '990002',
        quantities: [
            {quantity: 1, price: 1200, discount: 0}
        ],
        original_price: 1200,
        type: 'Bracelet',
        highest_bulk_option: 1,
        lowest_bulk_option: 1,
        discount_type: 'dollar'
    },
    "39909589844160": {
        handle: 'bamboo-straw',
        variant: 39909589844160,
        custom_bulk_quantity_selector: true,
        id: 6699127177408,
        sku: '990081',
        quantities: [
            {quantity: 4, price: 300, discount: 0},
            {quantity: 8, price: 200, discount: 0}
        ],
        original_price: 300,
        type: 'Straw',
        highest_bulk_option: 8,
        lowest_bulk_option: 4,
        discount_type: 'percent'
    }
};

window.SLIDECART_LOADED = function(cart) {
    // on load, set bubble count, even if undefined - we'll check later
    bubbleCount = document.getElementById('cart-icon-bubble').getElementsByClassName('cart-count-bubble')[0];
    if(cart) {
        cartAvailable = cart;
    }
}

window.SLIDECART_OPENED = function() {
    // Fires whenever Slide Cart has been opened
    if(cartLoadCounter === 0 && cartAvailable !== undefined) {
        fetch('/cart.js')
        .then(response => {
            return response.json();
        })
        .then(cart => {
            loopCartItemsAndUpdateSelectOptions(cart);
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }
}

window.SLIDECART_UPDATED = function(cart) {
    // loop over all items in the cart and build select dropdown
    loopCartItemsAndUpdateSelectOptions(cart);
    // if(cart.total_price > 10000) {
    //     addFreebieToCart();
    // }

    // Update the Bubble Count everytime the cart gets updated
    let cart_item_count = window.SLIDECART_STATE().cart.item_count;
    if(cart.item_count > 0) {
        if(bubbleCount == undefined) {
            document.getElementById('cart-icon-bubble').innerHTML += '<div class="cart-count-bubble"><span aria-hidden="true" id="cart-item-count">' + cart_item_count + '</span><span class="visually-hidden">' + cart_item_count + 'items</span></div>'
            bubbleCount = document.getElementById('cart-icon-bubble').getElementsByClassName('cart-count-bubble')[0];
        } else {
            bubbleCount.innerHTML = '<span aria-hidden="true" id="cart-item-count">' + cart_item_count + '</span><span class="visually-hidden">' + cart_item_count + 'items</span>'
        }
    } else {
        if(document.getElementById('cart-item-count')) {
            document.getElementById('cart-item-count').innerText = cart_item_count;
        }
    }
}

window.SLIDECART_ADD_TO_CART = function() {
    // Fires whenever an item has been added to cart
}

window.SLIDECART_REMOVED_FROM_CART = function({ id }) {
    // Fires whenever an item is removed from cart
}

window.SLIDECART_CHECKOUT = function () {
}

function loopCartItemsAndUpdateSelectOptions(cart) {
    ++cartLoadCounter;
    if(cart.items.length > 0) {
        // loop through cart items exclude products that don't need custom select options
        for(let cartItem of cart.items) {
            // not all items in cart item need custom quantity selectors, wrap in conditional
            // filter our cart item from list
            if(typeof allProducts[cartItem.variant_id] !== 'undefined' && allProducts[cartItem.variant_id].custom_bulk_quantity_selector !== false) {
                let slideCartItems = document.getElementById('slidecarthq').getElementsByClassName('item');
                let variantId = cartItem.variant_id;
                for(let slideItem of slideCartItems) {
                    // filter out the
                    let key = slideItem.getAttribute('data-line-item-key');
                    if(parseInt(slideItem.getAttribute('data-variant-id')) === parseInt(variantId)) {
                        let elem = slideItem.getElementsByClassName('quantity-selector')[0];
                        if(elem) {
                            elem.style.display = 'none';
                        }
                        let quantities = allProducts[cartItem.variant_id].quantities;
                        // set to cart item quantity
                        let currentQuantity = cartItem.quantity;
                        let customSelect = document.createElement('select');
                        customSelect.classList.add('js-change-select');
                        customSelect.setAttribute('id', 'update-select-'+ variantId);
                        let highestBulkQuantity = "";
                        let lowestBulkQuantity = "";
                        for (let qtyItem of quantities) {
                            // TODO: set custom option if more than 100
                            var option = document.createElement("option");
                            option.value = qtyItem.quantity;
                            if(currentQuantity === qtyItem.quantity) {
                                option.selected = true;
                            }
                            // custom option if greater than highest bulk option
                            // get the highest bulk option
                            // else set to lowest bulk option
                            let includeS = qtyItem.quantity === 1 ? '': 's';
                            option.text = qtyItem.quantity + ' ' + allProducts[cartItem.variant_id].type + '' + includeS;
                            customSelect.appendChild(option);
                        }
                        // maybe -- don't replace, but hide and trigger click on input element
                        // or -- add an on click event subscriber that triggers window.SLIDECART_SET_CART(cart)
                        // check if it only modifies single cart item element or do all elements get updated
                        if(!elem) {
                            slideItem.getElementsByClassName('js-change-select')[0].replaceWith(customSelect);
                        } else {
                            elem.replaceWith(customSelect);
                        }

                        customSelect.addEventListener("change", function(event) {
                            // ajax update cart item quantity
                            $.ajax({
                                url: '/cart/change.js',
                                dataType: 'json',
                                cache: false,
                                type: 'POST',
                                data: {
                                    'id': key,
                                    'quantity': parseInt(event.target.value)
                                },
                                success: function(cart) {
                                    // LTK cart function was here
                                    // refresh slide cart items
                                    window.SLIDECART_UPDATE();
                                }
                            });
                        });
                    } else {
                    }
                }
            } else {
            }
        }
    }
}

// on load, trigger input quantity to set the bulk price if there is only one quantity selection; ie. RTE variant of 18 items.
// switched to all products
$(':radio[name="custom-quantity"]').change(function() {
    let product_quantity = this.value;
    let variant = this.getAttribute('data-product-variant');
    $('input[name="quantity"]').attr('value', product_quantity);
    setBulkQuantityPrice(product_quantity, variant);
});

$('input[name="quantity"]').change(function() {
    let product_quantity = this.value;
    let variant = this.getAttribute('data-product-variant');
    setBulkQuantityPrice(product_quantity, variant);
});
$('input[name="quantity"]').trigger('change');

function setBulkQuantityPrice(product_quantity, variant) {
    for (let item of allProducts[variant].quantities) {
        if (product_quantity == item.quantity) {
            $('#bulk-sale-price').text('$' + (parseFloat(item.price) / 100).toFixed(2));
            if(item.price < allProducts[variant].original_price) {
                // show original price === quantity * original price
                $('#bulk-original-price').text('$' + (parseFloat(allProducts[variant].original_price) / 100).toFixed(2));
            } else {
                $('#bulk-original-price').text('');
            }
        }
    }
}

function addFreebieToCart() {
    fetch('/cart.js')
        .then(response => {
            return response.json();
        })
        .then(cart => {
            let freebie_product_id = 6699128553664;
            let freebie_variant_id = 39909592924352;
            let freebie_in_cart = false;
            let cost_of_freebie = 500;
            // if cart only contains freebie, remove it
            for (let item of cart.items) {
                if (item.product_id === freebie_product_id) {
                    freebie_in_cart = true;
                }
            }
            if(freebie_in_cart === false) {
                $.ajax({
                    url: '/cart/add.js',
                    dataType: 'json',
                    cache: false,
                    type: 'POST',
                    data: {
                        'items': [{
                            'id': freebie_variant_id,
                            'quantity': 1
                        }]
                    },
                    success: function() {
                        window.SLIDECART_UPDATE();
                    }
                });
            }
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}

function fetchCartAndUpdateListrakItems() {
    fetch('/cart.js')
        .then(response => {
            return response.json();
        })
        .then(cart => {
            // TODO: setTimeout function is not acceptable solution
            for (let item of cart.items) {
                _ltk.SCA.AddItemWithLinks(item.sku, item.quantity, item.discounted_price / 100, item.product_title, item.image, item.url);
            }
            _ltk.SCA.Submit();

        })
        .catch((error) => {
            console.error('Error:', error);
        });
}

